// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__a5rB-","container":"Page_container__go5JP","page":"Page_page__YtAAI","banner":"Page_banner__IHp7Y","footer":"Page_footer__c5pNO"};